var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoShort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 41 41"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 20.5,
    cy: 20.5,
    r: 20.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.1 6.8c-4.3 0-6.9 2.6-8 8.4-.3 1.3-.7 3.5-.9 4.6-.6 3.6-1 5.7-1.7 6.4-.8.9-2.4 1.5-2.9 1.7l.5 1.4.5 1.4c1.6-.5 3.1-.8 4.8-.8h12.9l.6-3H15.8c.7-1.4 1.1-3.5 1.6-6.7.2-1 .6-3.2.9-4.6 1.1-5.9 3.3-5.9 4.8-5.9.8 0 1.4.4 1.6.7.4.4.6 1 .5 1.5-.4 2.2-1.4 3.1-4.4 3.3l-.6 3c2.9-.1 7.2-.8 8.1-5.9.2-1.4-.2-2.8-1.2-3.9-1-.9-2.4-1.6-4-1.6"
  })));
}

export default SvgLogoShort;